// v2.19.22g — Splash screen AYA AI (masque sculpté, rotation, aura cyan).
// v2.19.23c — bascule sur PNG RGBA local (/aya/splash.png) avec alpha réel.
import "./AyaSplash.css";

const AYA_MASK_URL = "/aya/splash.png";

export default function AyaSplash({ visible }) {
  return (
    <div
      className={`aya-splash ${visible ? "aya-splash-visible" : "aya-splash-hidden"}`}
      aria-hidden={!visible}
      data-testid="aya-splash"
    >
      <div className="aya-splash-inner">
        <div className="aya-splash-aura" />
        <img src={AYA_MASK_URL} alt="AYA AI" className="aya-splash-mask" />
      </div>
      <div className="aya-splash-text">
        <h1 className="aya-splash-title">AYA AI</h1>
        <p className="aya-splash-tagline">L'intelligence locale, notre identité</p>
        <div className="aya-splash-loader">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );
}
